/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UnitRateCrawlerConfiguration {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return UnitRateCrawlerConfiguration.fixupPrototype; }

    static newInstance(model: Partial<UnitRateCrawlerConfiguration>): UnitRateCrawlerConfiguration {
        let obj = Object.assign(new UnitRateCrawlerConfiguration(), model);
        UnitRateCrawlerConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UnitRateCrawlerConfiguration>): UnitRateCrawlerConfiguration {
        if (!model) return null;
        return UnitRateCrawlerConfiguration.newInstance(<UnitRateCrawlerConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UnitRateCrawlerConfiguration) {
        if (!obj) return;

        models.UnitRateCrawlerConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UnitRateCrawlerConfiguration): boolean {
        switch (obj.__type)
        {
            case "UnitRateCrawlerConfigurationForAzureEA":
                Object.setPrototypeOf(obj, models.UnitRateCrawlerConfigurationForAzureEA.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof UnitRateCrawlerConfiguration)[] {
        return [
            models.UnitRateCrawlerConfigurationForAzureEA,
        ];
    }

    fixupFields() {
    }

}
